<script setup>
import FullPopup from '#/general/FullPopup'
import { useAnalyzer } from '#/analyzer/useAnalyzer'
import { useB2CAnalyzer } from 'src/composables/useB2CAnalyzer'
const { showMailNotificationPopup } = useAnalyzer()
const { form } = useB2CAnalyzer()
defineProps(['firstName', 'lastName'])
</script>

<template lang="pug">
full-popup(
  :fixed="true"
  :persistent="true"
  :full-screen="true"
  v-model:visible="showMailNotificationPopup"
  btn-label="Alles klar"
  title="Der Link zu Ihrer Potenzialanalyse wurde soeben versandt."
)
  .b2cMailBodyContainer
    .box Liebe/r {{form.fields.firstName.value}} {{form.fields.lastName.value}},
    .box soeben haben wir Ihnen per E-Mail einen Link zur Potenzialanalyse geschickt. Schauen Sie in Ihrem Postfach (gegebenenfalls auch Spam-Ordner) nach, um den Report einzusehen.
    .box Achtung: Um unser Produkt zu schützen, sind aktuell  maximal drei Adressabfragen pro NutzerIn möglich.
</template>

<style lang="sass" scoped>
.b2cMailBodyContainer
  color: #DCE7F2
  line-height: 130%
  @media screen and (min-width: 1024px)
    font-weight: 500
    font-size: 16px
  @media screen and (max-width: 1023px)
    font-weight: 500
    font-size: 14px
  .box
    margin-bottom: 20px
</style>
